const NS = '[session-map]';

function sessionMapDebugEnabled() {
  const nativeDev = (globalThis as typeof globalThis & { __DEV__?: boolean }).__DEV__ === true;
  const webDev = typeof window !== 'undefined'
    && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  if (nativeDev || webDev) {
    return true;
  }

  try {
    return localStorage.getItem('paddiq:debug:session-map') === '1';
  } catch {
    return false;
  }
}

export function sessionMapDebug(message: string, data?: Record<string, unknown>) {
  if (!sessionMapDebugEnabled()) {
    return;
  }

  if (data !== undefined) {
    console.info(`${NS} ${message}`, data);
  } else {
    console.info(`${NS} ${message}`);
  }
}

export function sessionMapDebugDuration(label: string, startedAtMs: number, data?: Record<string, unknown>) {
  sessionMapDebug(`${label} (${Math.round(performance.now() - startedAtMs)}ms)`, data);
}
